import type { FC } from 'react';
import React from 'react';

import type { MacroExperienceBase } from '@confluence/macro-tracker';
import {
	getExperienceName,
	getMacroAttributesFromADFNode,
	MacroExperienceStop,
} from '@confluence/macro-tracker';

export type InlineExternalImageParams = MacroExperienceBase & {
	height?: number | 'auto';
	width?: number | 'auto';
	src: string;
};

export const InlineExternalImage: FC<InlineExternalImageParams> = ({
	width = 'auto',
	height = 'auto',
	src,
	mode,
	node,
	contentId,
}: InlineExternalImageParams) => {
	const stopMacroExperience = (error: any) => {
		const attributes = getMacroAttributesFromADFNode(node);

		return (
			<MacroExperienceStop
				name={getExperienceName(mode, node)}
				contentId={contentId}
				mode={mode}
				error={error}
				attributes={attributes}
				source="InlineExternalImage"
			/>
		);
	};

	return (
		// eslint-disable-next-line jsx-a11y/alt-text
		<img
			style={{
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
				cursor: 'move',
			}}
			data-testid="external-image"
			width={width}
			height={height}
			src={src}
			onError={stopMacroExperience}
			onLoad={stopMacroExperience}
		/>
	);
};
